export default "<p class=\"text-danger\" style=\"font-size: 11px\">\n  {{ errorMessage }}\n</p>\n";